import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eda0720"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loggedin-elsewhere"
}
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = {
  class: "modal-wrapper",
  ref: "modalWrapper"
}
const _hoisted_4 = { class: "modal-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "You Are Already Logged In Elsewhere")
], -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" You can only be logged in on one browser at a time. If you wish to "),
  /*#__PURE__*/_createElementVNode("strong", null, "continue here"),
  /*#__PURE__*/_createTextVNode(", please select "),
  /*#__PURE__*/_createElementVNode("strong", null, "'Continue'"),
  /*#__PURE__*/_createTextVNode(" if "),
  /*#__PURE__*/_createElementVNode("strong", null, "not"),
  /*#__PURE__*/_createTextVNode(", select "),
  /*#__PURE__*/_createElementVNode("strong", null, "'Cancel'"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "text",
  style: {"color":"red"}
}
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = { class: "button-controls" }

export function render(_ctx, _cache) {
  return (_ctx.modalOpened)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_Transition, { name: "modal" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("i", {
                    class: "fal fa-times close-icon",
                    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.closeModal()), ["prevent"]))
                  }),
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    (_ctx.additionalMsg)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Please note that, if you wish to continue on this browser, you will lose your selections and answers from the last page you were on. Do you wish to continue from here? "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "btn btn-outline",
                        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.closeModal()), ["prevent"]))
                      }, "Cancel"),
                      _createElementVNode("button", {
                        class: "btn btn-secondary",
                        onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.continueClicked()), ["prevent"]))
                      }, "Continue")
                    ])
                  ])
                ])
              ], 512)
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}